// dynamic-product-names.js
(function() {
    'use strict';

    // Configuration
    const config = {
        productNameSelector: '.product__title, .product-title, h1, [class*="product"][class*="title"], [class*="title"][class*="product"]',
        variantKeywords: [
            'sallllllll'
        ]
    };

    let originalProductData = {
        title: '',
        variants: [],
        baseTitle: '',
        hasVariantInOriginalTitle: false,
        productSku: '',
        allSkus: [],
        isInitialized: false,
        currentVariant: null
    };

    function init() {
        // Prevent multiple initializations
        if (originalProductData.isInitialized) {
            console.log('Script already initialized, skipping...');
            return;
        }

        console.log('Dynamic product names script initialized on:', window.location.pathname);
        
        if (isProductPage()) {
            setTimeout(() => {
                initProductPage();
            }, 500);
        } else {
            setTimeout(() => {
                cleanAllProductTitles();
            }, 500);
        }
    }

    function isProductPage() {
        return window.location.pathname.includes('/products/') || 
               document.body.classList.contains('template-product');
    }

    function initProductPage() {
        if (originalProductData.isInitialized) {
            return;
        }
        
        console.log('Initializing product page');
        storeOriginalProductData();
        setupVariantListeners();
        setTimeout(updateProductTitle, 100);
        
        originalProductData.isInitialized = true;
    }

    function storeOriginalProductData() {
        const titleElement = document.querySelector(config.productNameSelector);
        if (titleElement) {
            originalProductData.title = titleElement.textContent.trim();
            console.log('Original title:', originalProductData.title);
        }

        // Get product data and collect ALL SKUs
        if (typeof window.product !== 'undefined' && window.product) {
            originalProductData.variants = window.product.variants || [];
            originalProductData.productSku = window.product.sku || '';
        } else if (typeof product !== 'undefined' && product) {
            originalProductData.variants = product.variants || [];
            originalProductData.productSku = product.sku || '';
        }

        // Collect all SKUs from product and variants
        originalProductData.allSkus = [];
        
        // Add main product SKU
        if (originalProductData.productSku) {
            originalProductData.allSkus.push(originalProductData.productSku.toLowerCase().trim());
        }
        
        // Add all variant SKUs and option values that look like SKUs
        originalProductData.variants.forEach(variant => {
            if (variant.sku) {
                originalProductData.allSkus.push(variant.sku.toLowerCase().trim());
            }
            // Also check option values that might be SKUs (contain dashes, numbers, etc.)
            if (variant.option1 && isLikelySku(variant.option1)) {
                originalProductData.allSkus.push(variant.option1.toLowerCase().trim());
            }
            if (variant.option2 && isLikelySku(variant.option2)) {
                originalProductData.allSkus.push(variant.option2.toLowerCase().trim());
            }
            if (variant.option3 && isLikelySku(variant.option3)) {
                originalProductData.allSkus.push(variant.option3.toLowerCase().trim());
            }
        });

        // Remove duplicates and empty values
        originalProductData.allSkus = [...new Set(originalProductData.allSkus)].filter(sku => sku && sku.length > 0);

        // Create base title by removing ALL SKUs and variants
        originalProductData.baseTitle = removeAllSkusAndVariants(originalProductData.title);
        
        // Check if original title contained any variant keywords (after SKU removal)
        const titleWithoutSku = removeAllSkus(originalProductData.title);
        originalProductData.hasVariantInOriginalTitle = titleWithoutSku !== removeVariantKeywords(titleWithoutSku);
        
        console.log('Base title (clean):', originalProductData.baseTitle);
        console.log('All SKUs found:', originalProductData.allSkus);
        console.log('Had variant in original title:', originalProductData.hasVariantInOriginalTitle);
    }

    // Check if a string looks like a SKU (contains dashes, numbers, uppercase letters)
    function isLikelySku(str) {
        if (!str || str.length < 3) return false;
        
        // Check for patterns that suggest it's a SKU
        const skuPatterns = [
            /[A-Z]{2,}-[A-Z0-9]+/,  // ROM-AUT30
            /[A-Z0-9]+-[A-Z0-9]+/,  // ABC-123
            /^[A-Z]{3,}[0-9]+$/,     // ABC123
            /[0-9]{3,}/              // Contains 3+ digits
        ];
        
        return skuPatterns.some(pattern => pattern.test(str));
    }

    function setupVariantListeners() {
        let isUpdating = false;
        
        document.addEventListener('change', function(e) {
            if (isUpdating) return;
            
            if (e.target.matches('input[type="radio"]') || 
                e.target.matches('select') || 
                e.target.matches('input[name*="option"]') ||
                e.target.matches('[name*="variant"]')) {
                
                isUpdating = true;
                setTimeout(() => {
                    updateProductTitle();
                    isUpdating = false;
                }, 150);
            }
        });

        document.addEventListener('click', function(e) {
            if (isUpdating) return;
            
            if (e.target.matches('input[type="radio"]') || 
                e.target.closest('.variant-wrapper') || 
                e.target.closest('.swatch')) {
                
                isUpdating = true;
                setTimeout(() => {
                    updateProductTitle();
                    isUpdating = false;
                }, 150);
            }
        });
    }

    function updateProductTitle() {
        const titleElement = document.querySelector(config.productNameSelector);
        if (!titleElement || !originalProductData.baseTitle) {
            console.log('No title element or base title found');
            return;
        }

        const selectedVariantName = getCurrentSelectedVariantName();
        console.log('Selected variant name:', selectedVariantName);
        
        // Prevent duplicate processing
        if (originalProductData.currentVariant === selectedVariantName) {
            console.log('Same variant, skipping update');
            return;
        }
        
        originalProductData.currentVariant = selectedVariantName;
        
        let newTitle;

        if (selectedVariantName && selectedVariantName.toLowerCase() !== 'default title') {
            // Check if the selected variant is a SKU
            const isVariantASku = originalProductData.allSkus.includes(selectedVariantName.toLowerCase().trim()) || 
                                isLikelySku(selectedVariantName);
            
            console.log('Is selected variant a SKU?', isVariantASku);
            
            if (isVariantASku) {
                // Don't show SKU, just use base title
                newTitle = originalProductData.baseTitle;
                console.log('Hiding variant because it is a SKU');
            } else {
                // Show variant as normal
                if (originalProductData.hasVariantInOriginalTitle) {
                    // Replace existing variant in the base title
                    newTitle = replaceVariantInTitle(originalProductData.baseTitle, selectedVariantName);
                } else {
                    // Add variant to the end
                    newTitle = `${originalProductData.baseTitle} ${selectedVariantName}`;
                }
                console.log('Adding/replacing variant in title');
            }
        } else {
            // No variant selected, use base title
            newTitle = originalProductData.baseTitle;
        }

        console.log('Updating title to:', newTitle);
        titleElement.textContent = newTitle;
    }

    function removeAllSkus(title) {
        let cleanedTitle = title;
        
        // Remove all collected SKUs from the title
        originalProductData.allSkus.forEach(sku => {
            if (sku && sku.length > 0) {
                const patterns = [
                    new RegExp(`\\s+${escapeRegExp(sku)}\\s*$`, 'gi'),
                    new RegExp(`^${escapeRegExp(sku)}\\s+`, 'gi'),
                    new RegExp(`\\s+${escapeRegExp(sku)}\\s+`, 'gi'),
                    new RegExp(`\\s+-\\s*${escapeRegExp(sku)}\\s*$`, 'gi'),
                    new RegExp(`^${escapeRegExp(sku)}\\s*-\\s*`, 'gi'),
                    new RegExp(`\\s+${escapeRegExp(sku)}$`, 'gi'),
                    new RegExp(`^${escapeRegExp(sku)}$`, 'gi'),
                    new RegExp(`\\b${escapeRegExp(sku)}\\b`, 'gi')
                ];
                
                patterns.forEach(pattern => {
                    const oldTitle = cleanedTitle;
                    cleanedTitle = cleanedTitle.replace(pattern, ' ');
                    if (oldTitle !== cleanedTitle) {
                        console.log(`Removed SKU "${sku}" from title`);
                    }
                });
            }
        });
        
        return cleanedTitle.replace(/\s+/g, ' ').trim();
    }

    function removeAllSkusAndVariants(title) {
        let cleanedTitle = removeAllSkus(title);
        cleanedTitle = removeVariantKeywords(cleanedTitle);
        return cleanedTitle;
    }

    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function replaceVariantInTitle(baseTitle, newVariant) {
        // For base title, just add the variant since it's already clean
        return `${baseTitle} ${newVariant}`;
    }

    function getCurrentSelectedVariantName() {
        const checkedRadio = document.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
            const label = document.querySelector(`label[for="${checkedRadio.id}"]`);
            if (label) return label.textContent.trim();
            if (checkedRadio.dataset.value) return checkedRadio.dataset.value;
        }

        const selects = document.querySelectorAll('select[name*="option"], select[name*="variant"]');
        for (let select of selects) {
            if (select.value && select.value !== '') {
                const selectedOption = select.options[select.selectedIndex];
                if (selectedOption && selectedOption.textContent.trim() !== '') {
                    return selectedOption.textContent.trim();
                }
            }
        }
        return null;
    }

    // Clean all product titles on non-product pages
    function cleanAllProductTitles() {
        console.log('Starting product title cleaning for search/collection pages...');
        
        const allElements = document.querySelectorAll('*');
        let cleanedCount = 0;
        
        allElements.forEach(element => {
            if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'META', 'LINK'].includes(element.tagName)) {
                return;
            }
            
            const directText = getDirectTextContent(element);
            if (directText && directText.length > 5) {
                const cleanedText = removeVariantKeywords(directText);
                
                if (cleanedText !== directText && cleanedText.length > 0) {
                    console.log('Cleaning text:', directText, '→', cleanedText);
                    replaceDirectTextContent(element, directText, cleanedText);
                    cleanedCount++;
                }
            }
        });
        
        console.log(`Cleaned ${cleanedCount} product titles`);
        setupDynamicObserver();
    }

    function getDirectTextContent(element) {
        let text = '';
        for (let node of element.childNodes) {
            if (node.nodeType === Node.TEXT_NODE) {
                text += node.textContent;
            }
        }
        return text.trim();
    }

    function replaceDirectTextContent(element, oldText, newText) {
        for (let node of element.childNodes) {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.includes(oldText)) {
                node.textContent = node.textContent.replace(oldText, newText);
            }
        }
    }

    function setupDynamicObserver() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            setTimeout(() => cleanNewElement(node), 100);
                        }
                    });
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function cleanNewElement(element) {
        const allElements = element.querySelectorAll ? [element, ...element.querySelectorAll('*')] : [element];
        
        allElements.forEach(el => {
            if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'META', 'LINK'].includes(el.tagName)) {
                return;
            }
            
            const directText = getDirectTextContent(el);
            if (directText && directText.length > 5) {
                const cleanedText = removeVariantKeywords(directText);
                
                if (cleanedText !== directText && cleanedText.length > 0) {
                    console.log('Dynamically cleaning:', directText, '→', cleanedText);
                    replaceDirectTextContent(el, directText, cleanedText);
                }
            }
        });
    }

    function removeVariantKeywords(title) {
        let cleanedTitle = title;
        
        config.variantKeywords.forEach(keyword => {
            const patterns = [
                new RegExp(`\\s+${keyword}\\s*$`, 'gi'),
                new RegExp(`^${keyword}\\s+`, 'gi'),
                new RegExp(`\\s+${keyword}\\s+`, 'gi'),
                new RegExp(`\\s+-\\s*${keyword}\\s*$`, 'gi'),
                new RegExp(`^${keyword}\\s*-\\s*`, 'gi'),
                new RegExp(`\\s+${keyword}$`, 'gi'),
                new RegExp(`^${keyword}$`, 'gi')
            ];
            
            patterns.forEach(pattern => {
                cleanedTitle = cleanedTitle.replace(pattern, ' ');
            });
        });
        
        return cleanedTitle.replace(/\s+/g, ' ').trim();
    }

    // Initialize only once
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(init, 100);
        });
    } else {
        setTimeout(init, 100);
    }

})();
